// www/src/pages/About.js
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import './About.css';

export default function About() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/business-info`)
      .then((r) => r.ok ? r.json() : null)
      .then(setInfo)
      .catch(() => setInfo({}));
  }, []);

  if (!info) return <main className="about-main"><div className="about-loading">Loading...</div></main>;

  return (
    <main className="about-main">
      <section className="about-top">
        <h1 className="about-title">{info.bioTitle || 'About'}</h1>
        {info.bioPhoto && <img className="about-photo" src={info.bioPhoto} alt="" />}
        <div className="about-body">
          {info.bioBody && <p className="about-bio">{info.bioBody}</p>}
        </div>
      </section>
      {info.credentials && (
        <section className="about-creds">
          <h2>Credentials</h2>
          <p>{info.credentials}</p>
        </section>
      )}
      {info.philosophy && (
        <section className="about-philosophy">
          <h2>Approach</h2>
          <p>{info.philosophy}</p>
        </section>
      )}
    </main>
  );
}
